import { useAuthenticatedApiClient, useJwtAuthenticatedApiClient } from '@guiker/react-framework'
import { AdminApiClient, AuthApiClient, JwtApiClient } from '@guiker/rent-payment-shared'

export const useAdminRentPaymentApiClient = useAuthenticatedApiClient(AdminApiClient)
export const useAuthRentPaymentApiClient = useAuthenticatedApiClient(AuthApiClient)
export const useJwtRentPaymentApiClient = useJwtAuthenticatedApiClient(JwtApiClient)
